// R4.B — Weekly retention worklist: MERAH/KUNING members with expiry <= 60 days,
// biggest score drop first. Data from GET /v1/bo/health-score/worklist (see
// backoffice.routes.js -> models.healthScore.getWorklist). Read-only report; acting
// on it (WhatsApp/email outreach) is Retention Engine (P2), not built yet.
let churnWorklistSection = {
  name: "Worklist Retensi",
  slug: "churnWorklist",
  visible: true,
  singularName: "churnWorklist",
  crud: true,
  endpoint: "/v1/bo/health-score/worklist",
  updateLabel: "churnWorklist",
  meta: {
    delete_flag: false,
  },
  access: ["superadmin"],
  delete: false,
  noNeedSearch: true,
  noNeedRefresh: false,
  add: false,
  update: false,
  edit: false,
  exportToCsv: true,
  fields: [
    {
      label: "Nama",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.name ? row.name : "-"),
    },
    {
      label: "Email",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.email ? row.email : "-"),
    },
    {
      label: "Skor",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.score_total != null ? row.score_total : "-"),
    },
    {
      label: "Δ vs bln lalu",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.score_delta != null ? row.score_delta : "-"),
    },
    {
      label: "Klasifikasi",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => {
        const icon = { HIJAU: "🟢", KUNING: "🟡", MERAH: "🔴" }[row.classification] || "";
        return `${icon} ${row.classification || "-"}`;
      },
    },
    {
      label: "Days to Expiry",
      name: "txt",
      type: "text",
      visible: true,
      resource_label: (row) => (row.days_to_expiry != null ? row.days_to_expiry : "-"),
    },
  ],
};

export default [churnWorklistSection];
